import { id } from "./id";
import { en } from "./en";

export type Translation = typeof id;
export type Language = "id" | "en";

export const translations: Record<Language, Translation> = {
  id,
  en,
};

export { id, en };
